<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0603'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="div-class">
          <h4>离线记录</h4>
          <!-- <el-button type="primary" class="btn-class" @click="handleAdd()">添加</el-button>
          <el-button type="primary" class="btn-class" @click="handleOne()">账户统一配置</el-button> -->
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="设备类型：" prop="type">
            <el-select v-model="searchForm.type" placeholder="请选择设备类型" clearable @change="typeChange">
              <el-option label="数值" :value="0"></el-option>
              <el-option label="视频" :value="1"></el-option>
              <el-option label="开关" :value="3"></el-option>
              <el-option label="网关" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称：" prop="eid">
            <el-select v-model="searchForm.eid" placeholder="请选择设备名称" clearable @change="deviceChange">
              <el-option v-for="(item, index) in deviceArray" :label="item.name" :value="item.id" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="属性名称：" prop="attributeId">
            <el-select v-model="searchForm.attributeId" placeholder="请选择属性名称" clearable @change="searchKey">
              <el-option v-for="(item, index) in attributeArray" :label="item.name" :value="item.id" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="attributeId">
            <el-date-picker v-model="searchForm.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="button" @click="searchKey()">查询</el-button>
            <el-button type="button" ass="button" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.type == 0">数值</p>
                <p v-if="scope.row.type == 1">视频</p>
                <p v-if="scope.row.type == 3">开关</p>
                <p v-if="scope.row.type == 4">网关</p>
              </template>
            </el-table-column> -->
            <el-table-column label="设备名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column v-if="searchForm.type==0||searchForm.type==3" label="属性名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="开始时间" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.startDate }}</p>
              </template>
            </el-table-column>
            <el-table-column label="结束时间" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.endDate }}</p>
              </template>
            </el-table-column>
            <!-- <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleUpdate(scope.row)" type="text">编辑</el-button>
                <el-button style="margin-left: -1rem;" type="text" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备类型：" prop="type">
                  <el-select v-model="ruleForm.type" placeholder="请选择设备类型" clearable @change="typeChange2">
                    <el-option label="数值" value="0"></el-option>
                    <el-option label="视频" value="1"></el-option>
                    <el-option label="开关" value="3"></el-option>
                    <el-option label="网关" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备名称：" prop="eid">
                  <el-select v-model="ruleForm.eid" placeholder="请选择设备名称" clearable @change="deviceChange2">
                    <el-option v-for="(item, index) in deviceArray2" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.type != 4">
              <el-col :span="24">
                <el-form-item label="属性名称：" prop="attributeId">
                  <el-select v-model="ruleForm.attributeId" placeholder="请选择属性名称" clearable>
                    <el-option v-for="(item, index) in attributeArray2" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="离线模板：" prop="modelOfflineSettingsId">
                  <el-select v-model="ruleForm.modelOfflineSettingsId" placeholder="请选择离线模板" clearable>
                    <el-option v-for="(item, index) in offlineArray" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose()">取消</el-button>
            <el-button type="primary" @click="handleSave()">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="账户统一配置" :visible.sync="dialogVisible2" width="600px" :before-close="handleClose2">
          <el-form ref="ruleForm2" :rules="rules2" :model="ruleForm2" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="离线模板：" prop="modelOfflineSettingsId">
                  <el-select v-model="ruleForm2.modelOfflineSettingsId" placeholder="请选择离线模板" clearable>
                    <el-option v-for="(item, index) in offlineArray2" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose2()">取消</el-button>
            <el-button type="primary" @click="handleSave2()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        type: 0,
        eid: '',
        attributeId: '',
        modelOfflineSettingsId: '',
        date: [],
        startTime: '',
        endTime: ''
      },
      ruleForm: {
        // 添加、编辑弹窗表单
        id: undefined,
        type: 0,
        eid: '',
        attributeId: '',
        modelOfflineSettingsId: ''
      },
      rules: {
        // 添加、编辑弹窗表单规则
        type: [
          {
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }
        ],
        eid: [
          {
            required: true,
            message: '请选择设备名称',
            trigger: 'change'
          }
        ],
        attributeId: [
          {
            required: true,
            message: '请选择属性名称',
            trigger: 'change'
          }
        ],
        modelOfflineSettingsId: [
          {
            required: true,
            message: '请选择离线模板',
            trigger: 'change'
          }
        ]
      },
      total: 0, // 总数
      tableData: [],
      ruleForm2: {
        // 用户统一配置弹窗表单
        modelOfflineSettingsId: ''
      },
      rules2: {
        // 用户统一配置弹窗表单规则
        modelOfflineSettingsId: [
          {
            required: true,
            message: '请选择离线模板',
            trigger: 'change'
          }
        ]
      },
      dialogVisible: false,
      title: '添加离线配置', // 添加、编辑弹窗标题
      deviceArray: [], // 设备数组
      attributeArray: [], // 属性数组
      offlineArray: [], // 离线模板数组
      deviceArray2: [], // 设备数组
      attributeArray2: [], // 属性数组
      offlineArray2: [], // 离线模板数组
      dialogVisible2: false // 用户统一配置弹窗是否显示
    }
  },
  created() {
    // 获取设备属性告警列表
    this.getDeviceAttributeOfflineList()

    // 获取离线模板列表
    this.getModelOfflineSettingsList()
  },
  methods: {
    // 关键字查询
    searchKey() {
      this.searchForm.pageNum = 1
      this.getDeviceAttributeOfflineList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getDeviceAttributeOfflineList()
    },
    // 重置
    reset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        type: 0,
        eid: '',
        attributeId: '',
        modelOfflineSettingsId: ''
      }
      this.attributeArray = []
      this.searchKey()
    },
    // 获取设备属性告警列表
    getDeviceAttributeOfflineList() {
      this.searchForm.startTime = this.searchForm.date[0]
      this.searchForm.endTime = this.searchForm.date[1]
      this.$api.offline.getDataHisOfflineList(this.searchForm).then((res) => {
        this.total = res.count
        this.tableData = res.data
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否确定删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$api.offline.delDeviceAttributeOffline(row.id).then((res) => {
          if (res.code == 200) {
            this.$toaster.ok(res.msg)
            this.searchKey()
          }
        })
      })
    },
    // 添加
    handleAdd() {
      this.title = '添加设备离线配置'
      this.ruleForm.id = ''
      this.dialogVisible = true
    },
    // 编辑
    handleUpdate(row) {
      this.title = '编辑设备离线配置'
      this.dialogVisible = true
      this.ruleForm.id = row.id

      // 获取设备属性离线
      this.getDeviceAttributeOffline(row.id)
    },
    // 获取设备属性离线
    getDeviceAttributeOffline(id) {
      //根据ID详情
      this.$api.offline.getDeviceAttributeOffline({ id: id }).then((res) => {
        if (res.code == 200) {
          res.data.type = res.data.type != undefined ? res.data.type.toString() : ''
          this.ruleForm = res.data

          // 获取设备列表
          this.getDeviceList2()

          // 获取属性列表
          this.getAttributeList2()
        }
      })
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$api.offline.saveDeviceAttributeOffline(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$toaster.ok(res.msg)
              this.handleClose()
              this.searchKey()
            }
          })
        } else {
          this.$toaster.error('保存失败，请先完善配置信息')
        }
      })
    },
    // 关闭添加编辑弹窗
    handleClose() {
      this.$refs['ruleForm'].resetFields()
      this.dialogVisible = false
    },
    // 类型下拉切换
    typeChange() {
      // 清空
      this.searchForm.eid = ''
      this.searchForm.attributeId = ''
      this.deviceArray = []
      this.attributeArray = []

      // 获取设备列表
      this.getDeviceList()

      // 查询
      this.searchKey()
    },
    // 设备下拉切换
    deviceChange() {
      // 清空
      this.searchForm.attributeId = ''
      this.attributeArray = []

      // 获取属性列表
      this.getAttributeList()

      // 查询
      this.searchKey()
    },
    // 类型下拉切换
    typeChange2() {
      // 清空
      this.ruleForm.eid = ''
      this.ruleForm.attributeId = ''
      this.deviceArray2 = []
      this.attributeArray2 = []

      // 获取设备列表
      this.getDeviceList2()
    },
    // 设备下拉切换
    deviceChange2() {
      // 清空
      this.ruleForm.attributeId = ''
      this.attributeArray2 = []

      // 获取属性列表
      this.getAttributeList2()
    },
    // 获取设备列表
    getDeviceList() {
      if (this.searchForm.type === '') {
        return
      }

      if (this.searchForm.type == 0) {
        // 数值设备
        this.$api.device.getDeviceNumericalAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 1) {
        // 视频设备
        this.$api.device.getDeviceVideoAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 2) {
        // 图片设备
        this.$api.device.getDevicePicAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 3) {
        // 开关设备
        this.$api.device.getDeviceSwitchAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 4) {
        // 网关设备
        this.$api.device.getDeviceGatewayAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray.push({
                id: val.id,
                name: val.gatewayName
              })
            })
          }
        })
      }
    },
    // 获取属性列表
    getAttributeList() {
      if (this.searchForm.type === '' || this.searchForm.type === '4' || this.searchForm.eid === '') {
        return
      }

      this.$api.device
        .getDeviceAttributes({
          type: this.searchForm.type,
          eid: this.searchForm.eid
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.attributeArray.push({
                id: val.id,
                name: val.cname
              })
            })
          }
        })
    },
    // 获取设备列表
    getDeviceList2() {
      if (this.ruleForm.type === '') {
        return
      }

      if (this.ruleForm.type == 0) {
        // 数值设备
        this.$api.device.getDeviceNumericalAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.ruleForm.type == 1) {
        // 视频设备
        this.$api.device.getDeviceVideoAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.ruleForm.type == 2) {
        // 图片设备
        this.$api.device.getDevicePicAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.ruleForm.type == 3) {
        // 开关设备
        this.$api.device.getDeviceSwitchAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.ruleForm.type == 4) {
        // 网关设备
        this.$api.device.getDeviceGatewayAll().then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.gatewayName
              })
            })
          }
        })
      }
    },
    // 获取属性列表
    getAttributeList2() {
      if (this.ruleForm.type === '' || this.ruleForm.type === '4' || this.ruleForm.eid === '') {
        return
      }

      this.$api.device
        .getDeviceAttributes({
          type: this.ruleForm.type,
          eid: this.ruleForm.eid
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.attributeArray2.push({
                id: val.id,
                name: val.cname
              })
            })
          }
        })
    },
    // 获取离线模板列表
    getModelOfflineSettingsList() {
      this.$api.offline.getModelOfflineSettingss().then((res) => {
        if (res.code == 200) {
          this.offlineArray = res.data
          this.offlineArray2.push({
            id: 0,
            name: '无'
          })
          res.data.forEach((val) => {
            this.offlineArray2.push({
              id: val.id,
              name: val.name
            })
          })
        }
      })
    },
    // 统一配置
    handleOne() {
      this.dialogVisible2 = true
      this.getUserOfflineSet()
    },
    // 获取用户统一配置
    getUserOfflineSet() {
      this.$api.offline.getUserOfflineSet().then((res) => {
        if (res.code == 200) {
          this.ruleForm2.modelOfflineSettingsId = res.data
        }
      })
    },
    // 关闭统一配置弹窗
    handleClose2() {
      this.ruleForm2.modelOfflineSettingsId = ''
      this.dialogVisible2 = false
    },
    // 保存统一配置
    handleSave2() {
      this.$refs['ruleForm2'].validate((valid) => {
        if (valid) {
          this.$api.offline
            .saveUserOfflineSet({
              modelOfflineSettingsId: this.ruleForm2.modelOfflineSettingsId
            })
            .then((res) => {
              if (res.code == 200) {
                this.$toaster.ok(res.msg)
                this.handleClose2()
              }
            })
        } else {
          this.$toaster.error('保存失败，请先完善配置信息')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}

.div-class {
  display: -webkit-box;
  -webkit-box-pack: justify;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

.btn-class {
  margin-top: 7px;
  margin-right: 10px;
}
</style>